import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import GeistMonoVariable from "./GeistMono-Variable.woff2";

// Geist Mono from the official Vercel font family. SIL OFL 1.1.
export const GeistMonoFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: GeistMonoVariable,
  },
];
